<template>
	<div class="header-banner">
		<div class="banner-img">
			<TransitionBanner :src="bannerSrc" :visible="bannerRendered" />
		</div>
		<ContentPad>
			<div class="banner-text">
				<div class="banner-text-title">{{ $t('enterprise.diagens.investor-relations') }}</div>
				<div
					v-html="$t('enterprise.diagens.investor-relations-description')"
					class="banner-text-description"
				></div>
			</div>
		</ContentPad>
	</div>
</template>

<script setup>
import TransitionBanner from '@/views/layout/components/TransitionBanner.vue';
import ContentPad from '@rebuild/materials/shared/common/ContentPad.vue';
import DIAGENS_BANNER from './diagens_banner.png';
import { ref } from 'vue';

const bannerSrc = ref('');
const bannerRendered = ref(false);
const loadBanner = () => {
	bannerSrc.value = DIAGENS_BANNER;
	bannerRendered.value = true;
};
loadBanner();
</script>

<style lang="less" scoped>
@diagens-banner-height: 120px;

.header-banner {
	height: @diagens-banner-height;
	position: relative;
	background: #f7f8fa;

	.banner-img {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
	}

	.banner-text {
		position: relative;
		z-index: 1;
		padding: 0 16px;
		height: @diagens-banner-height;
		color: #fff;
		font-family: 'Alibaba PuHuiTi';
		font-weight: 700;
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: 4px;
	}
	.banner-text-title {
		font-size: 21px;
		line-height: 28px;
	}
	.banner-text-description {
		font-size: 14px;
		line-height: 20px;
	}
}
</style>
